import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-weblink-menu',
  templateUrl: './weblink-menu.component.html',
  styleUrls: ['./weblink-menu.component.scss']
})
export class WeblinkMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
